import React from 'react';
import { motion } from 'framer-motion';
import './Section.css';

export function Section({ id, title, children }) {
  return (
    <section id={id} className="section">
      <motion.div
        initial={{ y: 20, opacity: 0 }}
        whileInView={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true, margin: '-100px' }}
        className="section-container"
      >
        <h3 className="section-title">{title}</h3>
        {children}
      </motion.div>
    </section>
  );
}
